export default "__VITE_ASSET__e3ed9b8e__"